import React from 'react';

const MaintenancePage = () => {
    return (
        <div className="min-h-screen bg-gradient-to-br from-primary-50 to-primary-100 flex items-center justify-center px-4">
        <div className="max-w-md w-full bg-white rounded-lg shadow-xl p-8 text-center">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">
        The Migration <span className="text-red-900">Experts</span>
        </h1>
        <div className="text-5xl my-6">🔧</div>
        <h2 className="text-xl font-semibold text-gray-800 mb-3">
        We&apos;ll be back soon
        </h2>
        <p className="text-gray-600">
        The site is temporarily down for scheduled maintenance.
        Please check back shortly.
        </p>
        </div>
        </div>
    );
};

export default MaintenancePage;
